export default __webpack_public_path__ + "static/media/banner2.246cb7b5.png";